/* eslint-disable i18next/no-literal-string */
import React from 'react';
import ReactCompareImage from 'react-compare-image';
import img1 from 'assets/images/general-landing/why/1.jpg';
import img1Final from 'assets/images/general-landing/why/1-final.jpg';
import img2 from 'assets/images/general-landing/why/2.jpg';
import img2Final from 'assets/images/general-landing/why/2-final.jpg';
import img3 from 'assets/images/general-landing/why/3.jpg';
import img3Final from 'assets/images/general-landing/why/3-final.jpg';
import img4 from 'assets/images/general-landing/why/4.jpg';
import img4Final from 'assets/images/general-landing/why/4-final.jpg';
import styles from './Why.module.scss';

const Reason = ({ leftImage, rightImage, title, description }) => (
  <div className={styles.reason}>
    <div className={styles.reasonImage}>
      <ReactCompareImage leftImage={leftImage} rightImage={rightImage} />
    </div>
    <div className={styles.reasonContent}>
      <span className={styles.reasonTitle}>
        {title}
      </span>
      <span className={styles.reasonDescription}>
        {description}
      </span>
    </div>
  </div>
);

export default function Why() {
  return (
    <div className="container">
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div className={styles.line1}>
            <div className={styles.tag}>
              [Transform Your Listing]
            </div>
            <div className={styles.line1Text}>
              Take control of your
            </div>
          </div>
          <div className={styles.line2}>
            property presentations with DIY Betates! This cutting-edge platform empowers Real Estate Agents, Realtors, and Home Sellers to create stunning, photorealistic virtual staging in minutes.
          </div>
        </div>
        <div className={styles.reasons}>
          <Reason
            leftImage={img1}
            rightImage={img1Final}
            title="Visual Transformation:"
            description="Watch as empty spaces morph into inviting rooms, filled with style and warmth."
          />
          <Reason
            leftImage={img2}
            rightImage={img2Final}
            title="Cost-Effective:"
            description="Discover a budget-friendly way to breathe life into listings without the need for physical furniture."
          />
          <Reason
            leftImage={img3}
            rightImage={img3Final}
            title="Customizable Designs:"
            description="Tailor each room to match the dreams and desires of potential buyers, creating a personal connection."
          />
          <Reason
            leftImage={img4}
            rightImage={img4Final}
            title="Increased Appeal:"
            description="Help buyers envision their future in these spaces, sparking interest and imagination."
          />
        </div>
      </div>
    </div>
  );
}
